import React, { useEffect, useState } from 'react';
import { getProductos, crearProducto, editarProducto, borrarProducto, autoClasificarProductos } from '../services/api';
import FiltroPanel from '../components/FiltroPanel';
import RibbonActions from '../components/RibbonActions';

const EMPTY = { codigo:'', nombre:'', descripcion:'', precio_unitario:0, iva_pct:19, impoconsumo_pct:0, unidad:'und', clasificacion_iva:'gravado', tipo_producto:'bien' };
const fmt = (n) => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', minimumFractionDigits:0 }).format(n || 0);

export default function Productos({ embedded, onCount }) {
  const [lista, setLista] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  const cargar = async (query = '') => {
    setLoading(true);
    try { const { data } = await getProductos(query); setLista(data); } catch { /* */ }
    finally { setLoading(false); }
  };
  useEffect(() => { cargar(); }, []);
  useEffect(() => { const t = setTimeout(() => cargar(q), 300); return () => clearTimeout(t); }, [q]);
  useEffect(() => { if (onCount) onCount(lista.length); }, [lista.length, onCount]);

  const abrirNuevo = () => { setForm(EMPTY); setEditId(null); setModal(true); };
  const [autoBusy, setAutoBusy] = useState(false);
  const autoClasificar = async () => {
    if (!window.confirm('Marcar como "servicio" los productos cuyo nombre lo indique (vuelo, mantenimiento, honorarios, arriendo, etc.). No cambia los que ya marcaste a mano. ¿Continuar?')) return;
    setAutoBusy(true);
    try { const { data } = await autoClasificarProductos(); alert(`Listo: ${data.marcados_servicio} productos marcados como servicio (de ${data.revisados} revisados).`); cargar(q); }
    catch (e) { alert('No se pudo auto-clasificar'); }
    finally { setAutoBusy(false); }
  };
  const abrirEditar = (p) => {
    setForm({ codigo:p.codigo||'', nombre:p.nombre, descripcion:p.descripcion||'', precio_unitario:p.precio_unitario||0, iva_pct:p.iva_pct??19, impoconsumo_pct:p.impoconsumo_pct??0, unidad:p.unidad||'und', clasificacion_iva:p.clasificacion_iva || (Number(p.iva_pct)>0?'gravado':'excluido'), tipo_producto:p.tipo_producto || 'bien' });
    setEditId(p.id); setModal(true);
  };
  const guardar = async (e) => {
    e.preventDefault();
    if (!form.nombre) return alert('El nombre es obligatorio');
    setSaving(true);
    try {
      if (editId) await editarProducto(editId, form); else await crearProducto(form);
      setModal(false); cargar(q);
    } catch (err) { alert(err.response?.data?.error || 'Error al guardar'); }
    finally { setSaving(false); }
  };
  const eliminar = async (p) => {
    if (!window.confirm(`¿Desactivar "${p.nombre}"?`)) return;
    await borrarProducto(p.id); cargar(q);
  };

  return (
    <div>
      {!embedded && (
        <div style={s.head}>
          <div>
            <h1 style={s.h1}>Productos / servicios</h1>
            <p style={s.sub}>{lista.length} productos {q ? 'encontrados' : 'en el catálogo'}</p>
          </div>
        </div>
      )}
      <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <FiltroPanel
          fields={[{ tipo: 'input', label: 'Buscar', value: q, onChange: setQ, placeholder: 'Nombre o código…', width: 230 }]}
          onClear={() => setQ('')}
        />
        <button style={s.btnSec} disabled={autoBusy} onClick={autoClasificar}>{autoBusy ? 'Clasificando…' : '🤖 Auto-clasificar bien/servicio'}</button>
        <button style={s.btnPrimary} onClick={abrirNuevo}>+ Nuevo producto</button>
      </div></RibbonActions>

      <div style={{ overflowX:'auto' }}>
        <table style={s.table}>
          <thead>
            <tr>{['Código','Nombre','Precio','IVA','INC','Unidad',''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {lista.map(p => (
              <tr key={p.id} style={s.tr}>
                <td style={s.td}>{p.codigo || '—'}</td>
                <td style={{ ...s.td, color:'#f1f5f9', fontWeight:500 }}>{p.nombre}</td>
                <td style={{ ...s.td, color: Number(p.precio_unitario) > 0 ? '#10b981' : '#64748b' }}>{fmt(p.precio_unitario)}</td>
                <td style={s.td}>{p.iva_pct}%</td>
                <td style={s.td}>{Number(p.impoconsumo_pct) > 0 ? `${p.impoconsumo_pct}%` : '—'}</td>
                <td style={s.td}>{p.unidad}</td>
                <td style={s.td}>
                  <div style={{ display:'flex', gap:6, justifyContent:'flex-end' }}>
                    <button style={s.iconBtn} title="Editar" onClick={() => abrirEditar(p)}>✏️</button>
                    <button style={{ ...s.iconBtn, borderColor:'#7f1d1d' }} title="Desactivar" onClick={() => eliminar(p)}>🚫</button>
                  </div>
                </td>
              </tr>
            ))}
            {!loading && lista.length === 0 &&
              <tr><td colSpan={7} style={{ ...s.td, textAlign:'center', padding:30, color:'#64748b' }}>
                {q ? 'Sin resultados.' : 'No hay productos. Importalos desde Siigo o creá uno nuevo.'}
              </td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={s.overlay} onClick={() => !saving && setModal(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <h2 style={s.modalTitle}>{editId ? 'Editar producto' : 'Nuevo producto'}</h2>
            <form onSubmit={guardar}>
              <div style={s.grid2}>
                <Field label="Código"><input style={s.input} value={form.codigo} onChange={e => setForm({ ...form, codigo:e.target.value })} /></Field>
                <Field label="Unidad"><input style={s.input} value={form.unidad} onChange={e => setForm({ ...form, unidad:e.target.value })} /></Field>
              </div>
              <Field label="Nombre *"><input style={s.input} value={form.nombre} onChange={e => setForm({ ...form, nombre:e.target.value })} /></Field>
              <Field label="Descripción"><textarea style={{ ...s.input, minHeight:60, resize:'vertical' }} value={form.descripcion} onChange={e => setForm({ ...form, descripcion:e.target.value })} /></Field>
              <div style={s.grid3}>
                <Field label="Precio unitario"><input style={s.input} type="number" min="0" value={form.precio_unitario} onChange={e => setForm({ ...form, precio_unitario:e.target.value })} /></Field>
                <Field label="IVA %"><input style={s.input} type="number" min="0" max="100" value={form.iva_pct} onChange={e => setForm({ ...form, iva_pct:e.target.value })} /></Field>
                <Field label="INC %"><input style={s.input} type="number" min="0" max="100" value={form.impoconsumo_pct} onChange={e => setForm({ ...form, impoconsumo_pct:e.target.value })} /></Field>
              </div>
              <Field label="Tipo (para la declaración de IVA: bienes / servicios)">
                <select style={s.input} value={form.tipo_producto} onChange={e => setForm({ ...form, tipo_producto:e.target.value })}>
                  <option value="bien">Bien (producto físico)</option>
                  <option value="servicio">Servicio</option>
                </select>
              </Field>
              {Number(form.iva_pct) === 0 && (
                <Field label="Clasificación de IVA (para la declaración)">
                  <select style={s.input} value={form.clasificacion_iva === 'gravado' ? 'excluido' : form.clasificacion_iva} onChange={e => setForm({ ...form, clasificacion_iva:e.target.value })}>
                    <option value="excluido">Excluido — no causa IVA</option>
                    <option value="exento">Exento — 0% con derecho a descontable</option>
                  </select>
                </Field>
              )}
              <div style={{ display:'flex', justifyContent:'flex-end', gap:12, marginTop:8 }}>
                <button type="button" style={s.btnSec} onClick={() => setModal(false)} disabled={saving}>Cancelar</button>
                <button type="submit" style={s.btnPrimary} disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const Field = ({ label, children }) => (
  <div style={{ marginBottom:14 }}>
    <label style={s.label}>{label}</label>
    {children}
  </div>
);

const s = {
  head: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 },
  h1: { fontSize:24, fontWeight:700, color:'#f1f5f9', margin:'0 0 4px' },
  sub: { color:'#64748b', fontSize:14, margin:0 },
  search: { width:'100%', maxWidth:420, height:40, padding:'0 14px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:14, outline:'none', marginBottom:16, boxSizing:'border-box' },
  table: { width:'100%', borderCollapse:'collapse', fontSize:13 },
  th: { color:'#64748b', fontSize:11, fontWeight:600, textAlign:'left', padding:'0 10px 10px', textTransform:'uppercase' },
  tr: { borderTop:'1px solid #334155' },
  td: { padding:'3px 10px', color:'#94a3b8' },
  btnMini: { background:'#0f172a', border:'1px solid #334155', color:'#7dd3fc', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer', marginRight:6 },
  iconBtn: { background:'#1e293b', border:'1px solid #334155', borderRadius:6, width:26, height:26, cursor:'pointer', fontSize:13, display:'inline-flex', alignItems:'center', justifyContent:'center', lineHeight:1 },
  btnPrimary: { background:'#3b82f6', color:'#fff', border:'none', borderRadius:10, padding:'10px 18px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSec: { background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 18px', fontSize:14, cursor:'pointer' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, zIndex:50 },
  modal: { background:'#1e293b', borderRadius:12, border:'1px solid #334155', padding: 18, width:'100%', maxWidth:560, maxHeight:'90vh', overflowY:'auto' },
  modalTitle: { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:'0 0 12px' },
  grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 },
  grid3: { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:14 },
  label: { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input: { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, outline:'none', boxSizing:'border-box' },
};
